/*! DO NOT EDIT: This file is auto-generated and will be overwritten. [build-fingerprint:assets:source={/app/_js/standalone/collection-boost-sd-custom/index.js}] */
"use strict";
(() => {
  // _js/standalone/collection-boost-sd-custom/index.js
  window.dataLayer = window.dataLayer || [];
  window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
      componentRegistry.useModulePlugin("FilterAPI", {
        name: "FilterAPI plugin",
        apply(builder) {
          builder.on("beforeMethodCall", "get", (payload) => {
            let collectionHandle = window.location.pathname.split("/").pop(), sizeSelected = payload.
            args[0].pf_opt_size;
            sizeSelected ? sessionStorage.setItem("selectedOption", sizeSelected[0]) : collectionHandle.
            includes("3x5") ? sessionStorage.setItem("selectedOption", "3x5'") : collectionHandle.includes(
            "5x7") ? sessionStorage.setItem("selectedOption", "5x7'") : collectionHandle.includes("6\
x9") ? sessionStorage.setItem("selectedOption", "6x9'") : collectionHandle.includes("8x10") ? sessionStorage.
            setItem("selectedOption", "8x10'") : collectionHandle.includes("9x12") ? sessionStorage.
            setItem("selectedOption", "9x12'") : sessionStorage.setItem("selectedOption", "");
          });
        }
      }), componentRegistry.useComponentPlugin("ProductList", {
        name: "Add Click Listener",
        enabled: !0,
        apply: () => ({
          afterRender() {
            document.querySelectorAll(
              ".boost-sd__product-link"
            ).forEach((link) => {
              link.addEventListener("click", () => {
                let clickUrl = link.getAttribute("href"), productTitle = link.closest(".boost-sd__pr\
oduct-item").querySelector(".boost-sd__product-title").innerText || "";
                window.dataLayer.push({
                  event: "plp_clickthrough",
                  page_path: window.location.pathname,
                  click_URL: clickUrl,
                  product_name: productTitle
                });
              });
            });
          }
        })
      }), componentRegistry.useComponentPlugin("ProductList", {
        name: "Add Tag Color Change",
        enabled: !0,
        apply: () => ({
          afterRender() {
            document.querySelectorAll(
              ".boost-sd__product-label-text"
            ).forEach((span) => {
              let spanText = span.innerText;
              spanText.toLowerCase().includes("new") && (span.parentElement.style.backgroundColor = "\
#b7c3ca", span.parentElement.style.color = "#2b292a"), spanText.toLowerCase().includes("faux") && (span.
              parentElement.style.backgroundColor = "#e5e9e9", span.parentElement.style.color = "#2b\
292a"), spanText.toLowerCase().includes("best") && (span.parentElement.style.backgroundColor = "#c6c\
bbe", span.parentElement.style.color = "#2b292a"), spanText.toLowerCase().includes("kids") && (span.
              parentElement.style.backgroundColor = "#aea1a7", span.parentElement.style.color = "#2b\
292a"), spanText.toLowerCase().includes("bcam") && (span.parentElement.style.backgroundColor = "#FFC\
ECE", span.parentElement.style.color = "#2b292a"), spanText.toLowerCase().includes("frida") && (span.
              parentElement.style.backgroundColor = "#3e4b0d", span.parentElement.style.color = "#fa\
f5ea", span.innerHTML = `<svg viewbox="0 0 582.3 111.5" width="74" height="14">
                <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" st\
roke-linejoin="round" d="M58.2,11.7c.9,10.9,5.9,75.2-11.2,90.7"></path>
                <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" st\
roke-linejoin="round" d="M127.1,23.6C62.1,21.8,6.6,35.4,6.6,35.4"></path>
                <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" st\
roke-linejoin="round" d="M35.1,63.3s1.9,3,60.9.9"></path>
                <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" st\
roke-linejoin="round" d="M99.1,107.3s23.1-6.3,23.1-63.7c1.1-.2,4.3,10.6,25.5,15.8-9.1,34.7,25.4,48.8\
,31.8,9.4-3,36.4,31.9,24.4,38.9,4"></path>
                <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" st\
roke-linejoin="round" d="M182.6,49.8c-1.2,0-1.2,1.8,0,1.8,1.2,0,1.2-1.8,0-1.8Z"></path>
                <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" st\
roke-linejoin="round" d="M252.1,71.2c-5.4-17.8-44.3,18.4-21.3,22.2,12.8-3.1,21.5-17.6,21.5-17.6"></p\
ath>
                <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" st\
roke-linejoin="round" d="M255.8,27.5c-5.5,54.3-2.7,79.6-2.7,79.6"></path>
                <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" st\
roke-linejoin="round" d="M285.2,70.6c-32.1-3.4-27.7,55.7,6.1,8.3-2.7,23.5,23.8,16.7,30,5.8"></path>
                <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" st\
roke-linejoin="round" d="M370.5,5.7s-10,45.8-11.5,92.9"></path>
                <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" st\
roke-linejoin="round" d="M410.9,4.2c0,18.1-89.6,88.5-101.4,34.3,25.9.7,90.5,58.5,92.9,56.7"></path>
                <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" st\
roke-linejoin="round" d="M435.6,67.7c-31.2-4.5-25.8,52.8,6.1,8.3-2.6,23.5,23.7,16.7,30,5.8,0,0,7.9-1\
1.4,16.3-42.9s3.3-13.7,3.7-17.3c-21.9-28.2-20.1,69-14.1,70.7,1.5,2.7,8-25,16.6-25s3.9,25.9,12.2,26.2\
c10.2,10.3,48.1-68.6,22.6-60.6-5.1,7.1-14,43.4-1.2,55.9,9.9,9.7,24.7,3.6,29.1.9,34.3,19,15.9-42.7-11\
.6-10.7"></path>
              </svg>`), spanText.toLowerCase().includes("%") && (span.parentElement.style.marginRight =
              "auto");
            });
          }
        })
      }), componentRegistry.useComponentPlugin("ProductPrice", {
        name: "Return current variant price",
        enabled: !0,
        apply: () => ({
          beforeRender(element) {
            let selectedOption = sessionStorage.getItem("selectedOption"), formatMoney = window.Shopify.
            formatMoney, moneyFormat = "${{amount_no_decimals}}", rootElement = element.getRootElm(),
            product = componentRegistry.getParentElmByPath(
              element,
              "ProductItem.ProductLink"
            ).getParams().props.product, variants = product.variants, discountTag = product.tags.find(
            (tag) => tag.includes("discount:")) || "discount:0", discount = Number(discountTag.split(
            ":")[1]), currentVariant = variants.find(
              (variant) => selectedOption && variant.title.indexOf(selectedOption) !== -1
            );
            if (currentVariant)
              if (discount) {
                let originalPrice = currentVariant.price, salePrice = originalPrice * (1 - discount /
                100), span = document.createElement("span");
                span.classList.add("boost-sd__product-price-original"), span.innerText = `${formatMoney(
                originalPrice * 100, moneyFormat)}`, rootElement.innerText = `${formatMoney(salePrice *
                100, moneyFormat)}`, rootElement.insertAdjacentHTML("afterbegin", span.outerHTML);
              } else {
                let salePrice = window.igData?.price?.getPriceByVariantId(currentVariant.id) || currentVariant.
                price;
                rootElement.innerText = `${formatMoney(salePrice * 100, moneyFormat)}`;
              }
            else if (product.price_min < product.price_max)
              if (discount) {
                let originalPriceMin = product.price_min, originalPriceMax = product.price_max, salePriceMin = originalPriceMin *
                (1 - discount / 100), salePriceMax = originalPriceMax * (1 - discount / 100);
                rootElement.innerText = `${formatMoney(salePriceMin * 100, moneyFormat)} - ${formatMoney(
                salePriceMax * 100, moneyFormat)}`;
              } else {
                let productId = product.id, minPrice = window.igData?.price?.getMinPriceByProductId(
                productId) || product.price_min, maxPrice = window.igData?.price?.getMaxPriceByProductId(
                productId) || product.price_max;
                rootElement.innerText = `${formatMoney(minPrice * 100, moneyFormat)} - ${formatMoney(
                maxPrice * 100, moneyFormat)}`;
              }
            else if (discount) {
              let originalPrice = product.variants[0].price, salePrice = originalPrice * (1 - discount /
              100), span = document.createElement("span");
              span.classList.add("boost-sd__product-price-original"), span.innerText = `${formatMoney(
              originalPrice * 100, moneyFormat)}`, rootElement.innerText = `${formatMoney(salePrice *
              100, moneyFormat)}`, rootElement.insertAdjacentHTML("afterbegin", span.outerHTML);
            } else {
              let price = window.igData?.price?.getPriceByVariantId(
                product.variants[0].id
              ) || product.variants[0].price;
              rootElement.innerText = `${formatMoney(price * 100, moneyFormat)}`;
            }
          }
        })
      }), componentRegistry.useComponentPlugin("ProductPrice", {
        name: "Add product label",
        enabled: !0,
        apply: () => ({
          beforeRender(element) {
            let rootElement = element.getRootElm(), handle = componentRegistry.getParentElmByPath(
              element,
              "ProductItem.ProductLink"
            ).getParams().props.product.handle;
            fetch(
              `${window.Shopify.routes.root}products/${handle}?view=meta-json`
            ).then((res) => res.json()).then((res) => {
              let productLabelData = res.label, previousSibling = rootElement.previousElementSibling;
              if (productLabelData) {
                if (previousSibling?.classList.contains(
                  "boost-sd__product-custom-label"
                ))
                  return;
                let div = document.createElement("div");
                div.classList.add("boost-sd__product-custom-label"), div.innerText = productLabelData.
                text, div.style.color = productLabelData.color, div.style.fontStyle = productLabelData.
                style, rootElement.insertAdjacentHTML("beforebegin", div.outerHTML);
              }
            });
          }
        })
      }), componentRegistry.useComponentPlugin("ProductImage", {
        name: "Return current variant image",
        enabled: !0,
        apply: () => ({
          beforeRender(element) {
            let selectedOption = sessionStorage.getItem("selectedOption"), currentMainImage = element.
            getRootElm().querySelector(
              ".boost-sd__product-image-img--main"
            );
            if (!currentMainImage)
              return;
            let currentMainImageSrc = currentMainImage.src, currentVariant = componentRegistry.getParentElmByPath(
              element,
              "ProductItem.ProductLink"
            ).getParams().props.product.variants.find(
              (variant) => selectedOption && variant.title.indexOf(selectedOption) !== -1
            );
            currentVariant && (currentMainImage.src = currentVariant.image, currentMainImage.srcset =
            currentMainImage.srcset.replaceAll(
              currentMainImageSrc,
              currentVariant.image
            ));
          }
        })
      }), componentRegistry.useComponentPlugin("ProductTitle", {
        name: "Add Rug Cover Label",
        enabled: !0,
        apply: () => ({
          beforeRender(element) {
            let rootElement = element.getRootElm(), nextSibling = rootElement.nextElementSibling, rugCoverLabelMetafield = componentRegistry.
            getParentElmByPath(
              element,
              "ProductItem.ProductLink"
            ).getParams().props.product.metafields.find(
              (metafield) => metafield.namespace === "product_card" && metafield.key === "rug_cover_\
label"
            );
            if (rugCoverLabelMetafield && !nextSibling.classList.contains("boost-sd__product-rug-lab\
el")) {
              let rugCoverLabel = rugCoverLabelMetafield.value, div = document.createElement("div");
              div.classList.add("boost-sd__product-rug-label"), div.innerText = rugCoverLabel, rootElement.
              insertAdjacentHTML("afterend", div.outerHTML);
            }
          }
        })
      }), componentRegistry.useComponentPlugin("ProductItem", {
        name: "Remove duplicate labels (Boost issue)",
        enabled: !0,
        apply: () => ({
          beforeRender(element) {
            let labels = element.getRootElm().querySelectorAll(".boost-sd__product-label"), seenLabels = /* @__PURE__ */ new Set();
            labels.forEach((label) => {
              let labelText = label.innerText;
              seenLabels.has(labelText) ? label.remove() : seenLabels.add(labelText);
            });
          }
        })
      });
    }
  ]);
})();
